import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { NorwoodQuiz } from "@/components/site/NorwoodQuiz";
import { ValueProps } from "@/components/site/ValueProps";
import { Footer } from "@/components/site/Footer";

const Results = lazy(() => import("@/components/site/Results").then(m => ({ default: m.Results })));
const Reviews = lazy(() => import("@/components/site/Reviews").then(m => ({ default: m.Reviews })));
const NoShaveFuture = lazy(() => import("@/components/site/NoShaveFuture").then(m => ({ default: m.NoShaveFuture })));
const NoShaveWhy = lazy(() => import("@/components/site/NoShaveWhy").then(m => ({ default: m.NoShaveWhy })));
const Guarantee = lazy(() => import("@/components/site/Guarantee").then(m => ({ default: m.Guarantee })));
const Pricing = lazy(() => import("@/components/site/Pricing").then(m => ({ default: m.Pricing })));
const DoctorBio = lazy(() => import("@/components/site/DoctorBio").then(m => ({ default: m.DoctorBio })));
const Surgeons = lazy(() => import("@/components/site/Surgeons").then(m => ({ default: m.Surgeons })));
const DoctorsGrid = lazy(() => import("@/components/site/DoctorsGrid").then(m => ({ default: m.DoctorsGrid })));
const RestoreLocationsMap = lazy(() => import("@/components/site/RestoreLocationsMap").then(m => ({ default: m.RestoreLocationsMap })));
const VirtualConsult = lazy(() => import("@/components/site/VirtualConsult").then(m => ({ default: m.VirtualConsult })));
const Faq = lazy(() => import("@/components/site/Faq").then(m => ({ default: m.Faq })));
const QuoteForm = lazy(() => import("@/components/site/QuoteForm").then(m => ({ default: m.QuoteForm })));

export const Route = createFileRoute("/hair-implants")({
  head: () => ({
    links: [{ rel: "canonical", href: "https://restorehair.com/hair-implants/" }],
    meta: [
      { title: "RESTORE® Hair | #1 in Hair Implants" },
      {
        name: "description",
        content:
          "Get your hair back with the leaders in hair implants, offering FUE hair implants & No-Shave Hair Restoration. Get a free consult today!",
      },
      { property: "og:title", content: "RESTORE® Hair | #1 in Hair Implants" },
      {
        property: "og:description",
        content:
          "Leaders in hair implants. Soft, natural, undetectable results — trusted by celebrities, athletes & everyday guys.",
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <Hero eyebrow="RESTORE® Hair | Hair Implants" />
        <NorwoodQuiz />
        <ValueProps hideEyebrowMobile />
        <Suspense fallback={null}>
          <Results hideEyebrowMobile />
          <Reviews hideEyebrowMobile />
          <NoShaveFuture />
          <NoShaveWhy />
          <Guarantee imageClassName="mt-5 md:mt-[50px]" />
          <Pricing hideHeadline />
          <DoctorBio />
          <Surgeons />
          <DoctorsGrid />
          <RestoreLocationsMap title="RESTORE Hair Implant Locations" hideList />
          <VirtualConsult />
          <Faq />
          <QuoteForm />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
